<div class="wrapper mx-auto mt-3" style="max-width: 700px; width: 100%;">
  <div class="container">
    <div class="row job-card py-3 border bg-white rounded">
      <!-- Left Side: Job Image (For Large Screens) -->
      <div class="col-lg-5 d-none d-lg-block">
        <div class="ratio ratio-1x1">
          <img [src]="data.data?.image || 'https://static.vecteezy.com/system/resources/previews/002/204/954/large_2x/we-are-hiring-banner-design-vector.jpg'" 
               class="job-image img-fluid rounded" alt="Job Image"
                data-bs-toggle="modal" data-bs-target="#imageModal">
        </div>
      </div>

      <!-- Right Side: Job Details -->
      <div class="col-lg-7 col-12">
        <!-- Recruiter Profile Section -->
        <div class="d-flex align-items-center mb-3">
          <img [src]="data.data?.Recruiter?.profilePicture || 'https://static.vecteezy.com/system/resources/previews/002/204/954/large_2x/we-are-hiring-banner-design-vector.jpg'" 
               class="profile-img me-3 img-fluid rounded-circle object-fit-cover"
               style="height: 70px; width: 70px; border-radius: 50%;" alt="Recruiter Profile Image"
               data-bs-toggle="modal" data-bs-target="#imageModal">
          <div class="d-flex flex-column">
            <button (click)="redirectToRecruiter()" class="btn px-2">
              <div class="fw-bold text-primary">
                Ravish Rajput{{ data.data?.Recruiter?.name}}
              </div>
            </button>
            <span class="text-muted small mb-0 ms-2"><i class="bi bi-briefcase"></i>&nbsp;&nbsp;{{ data.data?.Recruiter?.position }} Recruiter</span>
            <span class="text-muted small mb-0 ms-2"><i class="bi bi-calendar"></i>&nbsp;&nbsp;{{ data.data?.created | date }}</span>
          </div>
           <!-- Status Button (Left) -->
           <button class="btn bg-primary rounded ms-auto share-btn me-2" (click)="toggleButtonClick('status')">
            <i *ngIf="data.data?.status === 'New'" class="bi bi-plus-circle"></i>
            &nbsp;&nbsp;<span>{{ data.data?.status
              }}</span>
          </button>
        </div>

        <!-- Image (For Mobile) -->
        <div class="d-lg-none text-center mb-3">
          <div class="ratio ratio-4x3">
            <img [src]="data.data?.image || 'https://static.vecteezy.com/system/resources/previews/002/204/954/large_2x/we-are-hiring-banner-design-vector.jpg'" class="news-image img-fluid rounded" alt="News Image"
               data-bs-toggle="modal" data-bs-target="#imageModal">
          </div>

        </div>

        <!-- Job Title -->
        <h5>Postion: {{ data.data?.title }}</h5>

        <!-- Job Description -->
        <strong>Description: </strong><p class="text-muted" style="white-space: normal; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; line-clamp: 3;" (click)="redirectToJobDetails()">
          {{ data.data?.description }} 
        </p>

        <!-- Job Details -->
        <div class="job-details">
          <div class="d-flex flex-wrap">
            <span><strong>Company:</strong> Tech Solutions</span>
            <span ><strong>Location:</strong> New York, USA</span>&nbsp;&nbsp;<span><strong>Experience:</strong> 2+ years</span>
            <span ><strong>Salary:</strong> $80,000 - $100,000</span>&nbsp;&nbsp;<span><strong>Job Type:</strong> Full-time</span>
          </div>
          <div class="position-relative w-100 text-wrap mt-2">
            <span><strong>Skills Required:</strong> HTML, CSS, JavaScript, Angular, React, MySQL, PostgreSQL, MongoDB</span>
          </div>
        </div>        

        <!-- Like, Dislike, Comment -->
        <div class="d-flex align-items-center mb-2 mt-1">
          <button class="btn btn-sm" (click)="toggleButtonClick('like')">
            <i class="bi bi-hand-thumbs-up fs-6 me-1"></i>
            <span>{{ data.data?.LikeDislikeSummary?.likes || 0 }}</span>
          </button>
          <button class="btn btn-sm" (click)="toggleButtonClick('dislike')">
            <i class="bi bi-hand-thumbs-down fs-6 me-1"></i>
            <span>{{ data.data?.LikeDislikeSummary?.dislikes || 0 }}</span>
          </button>
          <button class="btn btn-sm" (click)="openCommentModal($event)">
            <i class="bi bi-chat fs-6 me-1"></i>
            <span>{{ data.data?.LikeDislikeSummary?.comments || 0 }}</span>
          </button>
          <!-- apply now and view Recruiter button -->
          <button (click)="applyJob()" class="btn btn-success btn-sm ms-auto me-1">{{ config.applyText || 'Apply Now' }}</button>
          <button (click)="redirectToRecruiter()" class="btn btn-secondary btn-sm ms-auto me-1">{{ config.viewRecruiterText || 'View Recruiter' }}</button>
           <!-- Share Button (Right) -->
           <button class="btn btn-warning btn-sm ms-auto me-2" (click)="onShareClick($event)">
            <i class="bi bi-share"></i>
            <span *ngIf="!config?.useIcons">&nbsp;&nbsp;{{ data?.data?.share }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
